module.exports = __webpack_public_path__ + "img/logo1.754eafc2.png";